import { useMemo } from 'react';
import { atom } from 'jotai';
import { createResourceAtom } from 'lib/atoms';
import type { AreaWorkspace } from 'types/area-workspace';
import type { AreaGeometry } from 'types/area-geometry';

// Self href of the workspace open in-page (local state, not a route), as pre-drill's
// launcher does it. Set by Create and the drawer; cleared by Back and promote / remove.
export const activeAreaWorkspaceHrefAtom = atom<string | null>(null);

// ── Reads (GET resource atoms, keyed by hypermedia href) ────────────────────

// The workspace envelope. `keep-old-data-on-refetch` so the shell doesn't drop to a
// spinner while a lifecycle write refreshes it.
export function useAreaWorkspaceResourceAtom(href: string | null | undefined) {
  return useMemo(
    () =>
      createResourceAtom<AreaWorkspace>(
        href ?? undefined,
        'keep-old-data-on-refetch'
      ),
    [href]
  );
}

// The area under review, fetched from the link on the workspace's detail block so the
// association stays the backend's to declare.
export function useAreaWorkspaceAreaAtom(href: string | null | undefined) {
  return useMemo(
    () =>
      createResourceAtom<AreaGeometry>(
        href ?? undefined,
        'keep-old-data-on-refetch'
      ),
    [href]
  );
}
